<template>
	<div id="orders" class="page"
		title="加载"
		v-infinite-scroll="loadMore"
		infinite-scroll-disabled="loading"
		infinite-scroll-distance="50">
		<div class='fenxiao-order'>
			<div class='order-list' v-for="item in orderList" style="margin:5px 10px;border-radius:10px;line-height:35px;">
				<div style="font-size:14px;text-indent:15px;border-bottom:1px solid #efefef;">订单日期：{{item.create_at}}</div>
				<div style="font-size:14px;text-indent:15px;border-bottom:1px solid #efefef;">订单内容：{{item.message}}</div>
				<div style="font-size:14px;text-indent:15px;border-bottom:1px solid #efefef;">订单金额：<span style="font-weight:bold;color:red">￥{{item.total_price}}</span></div>
			</div>
		</div>
		<p v-show="loading" class="loading-tips" style="text-align:center;">
			<wv-spinner type="snake" color="#444" :size="24"/>
		</p>
	</div>
</template>

<script>
import { Toast , Dialog} from 'we-vue'
export default {
	data () {
		return {
			loaded:false,
			orderList:[],
			loading:false,
			page:1
		}
	},
	created () {
		
	},
	methods: {
		loadMore(){
			if(this.loaded){
				return false
			}
			this.loading = true
			this.$https.post("/api/order/mylists",this.$qs.stringify({
				token:this.$store.state.token,
				page:this.page
			})).then((res) => {
				if(res.data.data.length < 1){
					this.loaded = true;
				}
				for(var n in res.data.data){
					this.orderList.push(res.data.data[n])
				}
				this.loading = false
				this.page++;
			}).catch(() => {
				
			});
		}
	},
	filters: {
    
	}
}
</script>

<style scoped>
	#orders{
		background-color:#efefef;
		min-height:100vh;
	}
	.order-list{
  margin-bottom: 10px;
  background: #fff;
}
.order-list .top{
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #ededed;
  font-size: 14px;
  padding: 10px;
}
.order-list .top .right{
  color: #eb6100;
}
.order-list .bottom{
  display: flex;
  padding: 10px;
  align-items: center;
  font-size: 14px;
}
.order-list .bottom view{
  text-align: center;
}
.order-list .bottom .left{
  text-align: left;
  display: flex;
  align-items: center;
   flex: 2;
}
.order-list .bottom .middle{
  flex: 1;
}
.order-list .bottom .right{
  flex: 2;
}
.order-list .bottom .right text{
  color: #eb6100;
}
.order-list .bottom .left image{
  width: 60px;
  height: 60px;
  border-radius: 100%;
  margin-right: 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/Orders.vue